// istanbul ignore file

import { CollapsibleSection } from './CollapsibleSection';
export default CollapsibleSection;

export { CollapsibleSection } from './CollapsibleSection';
export { NonCollapsibleSection } from './NonCollapsibleSection';
